import { ReplenishmentTemplateCategoryDetailPage } from '@/features/replenishment-template-category/pages/ReplenishmentTemplateCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateCategoryDetailPage,
});
